const networks = Object.freeze({
  Ossa: 'ossa',
  Spotify: 'spotify',
  Colture: 'colture',
});

export default networks;
